import React from 'react';
// eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
import { useFragment, graphql } from 'react-relay';
import { UpdatedDate as UpdatedDateFieldReadView } from '@atlassian/jira-updated-date/src/ui/read/main.tsx';
import type { ui_issueViewLayoutMetaUpdatedDateField_IssueViewUpdatedDateField$key } from './__generated__/ui_issueViewLayoutMetaUpdatedDateField_IssueViewUpdatedDateField.graphql';

export interface IssueViewUpdatedDateFieldProps {
	fragmentKey: ui_issueViewLayoutMetaUpdatedDateField_IssueViewUpdatedDateField$key;
}

export const IssueViewUpdatedDateField = ({
	fragmentKey,
}: IssueViewUpdatedDateFieldProps): React.JSX.Element | null => {
	const data = useFragment<ui_issueViewLayoutMetaUpdatedDateField_IssueViewUpdatedDateField$key>(
		// eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
		graphql`
			fragment ui_issueViewLayoutMetaUpdatedDateField_IssueViewUpdatedDateField on JiraDateTimePickerField {
				dateTime
			}
		`,
		fragmentKey,
	);

	if (!data.dateTime) {
		return null;
	}

	return <UpdatedDateFieldReadView date={data.dateTime} />;
};
